import { Map, OrderedMap } from "immutable";

import { ACTIONS } from "app/app.constants";

import employeeCourseMappers from "app/mappers/employeeCourse.mappers";

const initialState = Map({
  courses: Map(),
});

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.CLEAR_COURSE_TRAINING_HISTORY_REPORT: {
      return initialState;
    }

    case ACTIONS.GET_COURSE_TRAINING_HISTORY_REPORT: {
      if (error) return state;

      return state.set(
        "courses",
        OrderedMap(
          payload.map(course => [
            course.courseId.toString(),
            employeeCourseMappers.CourseTrainingReport.from(course),
          ]),
        ),
      );
    }

    default:
      return state;
  }
};
